<template>
  <div class="min-h-screen flex flex-col items-center justify-center p-5 bg-primary30">
    <div class="mb-12">
      <Logo width="160px" logo="full_text_white" />
    </div>

    <div class="w-full flex justify-center">
      <div
        class="w-full max-w-md bg-white rounded shadow-lg p-10 flex flex-col items-center text-center"
      >
        <h1 class="font-inter font-bold text-lg leading-7 text-[#333333] mb-4">
          O cadastro de médicos é feito pelo aplicativo
        </h1>
        <p class="font-inter text-base text-gray-600 mb-8 max-w-xs sm:max-w-sm">
          Baixe o app Minha Escala, crie sua conta e gerencie seus plantões direto do celular.
        </p>

        <AppStoreBadges class="mb-4 justify-center" />

        <FilledButton
          v-if="isMobileDevice"
          text="Abrir loja de aplicativos"
          width="100%"
          class="mb-4"
          @click="openStore"
          data-testid="signup-doctor-open-app-button"
        />

        <router-link :to="PATHS.SIGNIN" class="w-full">
          <GhostButton
            text="Voltar para o login"
            width="100%"
            data-testid="signup-doctor-back-login-button"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useToast } from 'vue-toastification'
import Logo from '@/components/designSystem/Logo/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import AppStoreBadges from '@/components/designSystem/AppStoreBadges/index.vue'
import { isMobileUserAgent, openAppStore } from '@/utils/appStoreLinks'
import PATHS from '@/router/paths'

const toast = useToast()
const isMobileDevice = ref(false)

onMounted(() => {
  isMobileDevice.value = isMobileUserAgent()
})

const openStore = () => {
  openAppStore(() =>
    toast.info('Abra a loja de aplicativos do seu celular e procure por "Minha Escala"')
  )
}
</script>
